import { PublicClientApplication } from "@azure/msal-browser";

const clientId = process.env.REACT_APP_MSAL_CLIENT_ID;
const authority = process.env.REACT_APP_MSAL_AUTHORITY;
const redirectUri = process.env.REACT_APP_MSAL_REDIRECT_URI;

console.log("Client ID:", clientId);
console.log("Authority:", authority);
console.log("Redirect URI:", redirectUri);

if (!clientId || !authority || !redirectUri) {
  throw new Error("Missing environment variables for MSAL configuration.");
}

const msalConfig = {
  auth: {
    clientId,
    authority,
    redirectUri,
  },
  cache: {
    cacheLocation: "localStorage", // Store tokens in localStorage
    storeAuthStateInCookie: true, // Recommended for IE11 or Edge
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

